import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  SkipSelf,
} from '@angular/core';
import {
  ControlContainer,
  FormGroupDirective,
  UntypedFormGroup,
  ValidationErrors,
} from '@angular/forms';
import { InfoOption } from '@app/forms/subscription/components/info/info.component';
import { FundsOriginList } from '@app/forms/subscription/definition/interface/subscription';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { delay } from 'rxjs';

@UntilDestroy()
@Component({
    selector: 'funds-initial-scpi',
    templateUrl: './funds-initial-scpi.component.html',
    styleUrls: ['./funds-initial-scpi.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class FundsInitialScpiComponent implements OnInit, AfterViewInit {
  @Input() derrors: any = false;
  error: ValidationErrors = null;
  pledgeProducts: any;
  optionInfo1: InfoOption = {
    icon: 'warning',
    backgroundColor: '#fae4e4',
    iconColor: '#a00d0d',
    textColor: '#a00d0d',
  };
  optionInfo2: InfoOption = {
    icon: 'warning',
    backgroundColor: '#FFF9F0',
    iconColor: '#876A33',
    textColor: '#876A33',
  };
  constructor(
    private controlContainer: FormGroupDirective,
    private cd: ChangeDetectorRef,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {}
  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }
  get form() {
    return this.controlContainer.form.get('parameters') as UntypedFormGroup;
  }

  ngOnInit() {
    this.pledgeProducts = this.subscriptionFacade.getPledge()?.products;
    this.form
      .get('fundsOriginList')
      .valueChanges.pipe(untilDestroyed(this), delay(0))
      .subscribe((data: FundsOriginList[]) => {
        if (data.length > 0) {
          const allSameRepartitionType = data.every(
            item => item.repartitionType === data[0].repartitionType,
          );
          if (!allSameRepartitionType) {
            this.form.get('fundsOriginList').setErrors({
              incorrect: true,
              message:
                'Les types de répartition doivent être identiques pour toutes les lignes',
            });
          } else {
            let sum = 0;

            sum = data.reduce((acc, curr) => {
              sum += Number(curr.distribution);
              return sum;
            }, 0);

            const isRepartitionAmount = data[0].repartitionType === 'AMOUNT';
            const suffix = isRepartitionAmount ? '€' : '%';
            const totalRepartitionToCheck = isRepartitionAmount
              ? this.form?.get('scpiInvestmentPrice')?.value || 0
              : 100;

            if (sum != totalRepartitionToCheck) {
              this.form.get('fundsOriginList').setErrors({
                incorrect: true,
                message: `La somme des parts réalisées doit être égale à ${totalRepartitionToCheck}${suffix}`,
              });
            } else {
              this.form.get('fundsOriginList').setErrors(null);
            }
          }
        }
        this.error = this.form.get('fundsOriginList').errors;
      });
    this.cd.detectChanges();
  }
}
